var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "fixed-content" }, [
      _c("div", { staticClass: "flex gap-20" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                _vm.$emit("handleClickAdd")
              }
            }
          },
          [
            _vm._v("\n        " + _vm._s(_vm.textBtnAdd) + "\n        "),
            _c("i", {
              staticClass: "fa fa-cube fa-lg mr-l-5",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                _vm.$emit("handleClickRegister")
              }
            }
          },
          [
            _vm._v("\n        " + _vm._s(_vm.textBtnRegister) + "\n        "),
            _c("i", {
              staticClass: "fa fa-check fa-lg mr-l-5",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ba25cf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba25cf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/components/FixedHeader.vue
// module id = null
// module chunks = 